import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  Box,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  MenuItem,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import {
  createProductVariantThunk,
  updateProductVariantThunk,
} from "store/reducers/product/productVariantSlice";
import { useEffect } from "react";

const validation = yup.object({
  price: yup.number("Enter price").required("Price required").positive().min(1),
  expiry_date: yup.string("Enter expiry date").required("Expiry date required"),
});

const ProductVariantForm = ({
  product_id,
  variant,
  fullGrid = false,
  onSubmit,
}) => {
  // console.log("ProductVariantForm rendered with variant:", variant);

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      price: variant?.price ?? 1,
      expiry_date:
        variant?.expiry_date ?? moment().add(7, "days").format("YYYY-MM-DD"),
    },
    validationSchema: validation,
    onSubmit: (data) => {
      if (variant) {
        dispatch(updateProductVariantThunk({ id: variant.id, data: data }));
      } else {
        dispatch(createProductVariantThunk({ ...data, product: product_id }));
      }
    },
    validateOnChange: false,
    enableReinitialize: true,
  });

  const { loading, success } = useSelector((state) => state.productVariant);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0) {
      console.log("Formik Errors:", formik.errors);
    }
  }, [formik.errors]);

  // useEffect(() => {
  //   console.log("Loading state:", loading);
  // }, [loading]);

  return (
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4} gap={2}>
            <TextField
              label="Price"
              variant="outlined"
              name="price"
              fullWidth
              value={formik.values.price}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.price)}
              helperText={formik.errors.price}
              autoComplete="new-password"
              type="number"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">₹</InputAdornment>
                ),
              }}
            />

            <LocalizationProvider dateAdapter={AdapterMoment} >
              <DesktopDatePicker
                label="Expiry date"
                inputFormat="YYYY-MM-DD"
                name="expiry_date"
                value={formik.values.expiry_date}
                onChange={(value) =>
                  formik.setFieldValue(
                    "expiry_date",
                    value.format("YYYY-MM-DD"),
                    true
                  )
                }
                renderInput={(params) => (
                  <TextField fullWidth variant="outlined" {...params} sx={{mt:2}}/>
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        {success?.update && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}
        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={
            loading?.create === product_id ||
            loading?.update === (variant?.id ?? 0)
          }
        >
          {variant ? "Update" : "Add"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default ProductVariantForm;
